import { render, staticRenderFns } from "./ProductsSizesMaps.vue?vue&type=template&id=0d04a173&"
import script from "./ProductsSizesMaps.vue?vue&type=script&lang=js&"
export * from "./ProductsSizesMaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports